/* istanbul ignore file */
import { Component, Input } from '@angular/core';
import { IUpgradeBanner } from 'src/app/model/sitefinity/IDashboard';

/**
 * @deprecated This component should not be enhanced ever. Make a new component if you need something similar to this.
 * This component is only used for the PGH Organic client. It is only shown when the dealer code matches the appSettings.ptpoId
 * and that is always set to PTPQA
 * 
 * We should delete this component when we sunset the PGH Organic site.
 */
@Component({
  selector: 'pgh-upgrade-callout',
  templateUrl: './upgrade-callout.component.html',
  styleUrls: ['./upgrade-callout.component.scss']
})
export class UpgradeCalloutComponent {
  @Input() upgradeBanner: IUpgradeBanner;
}
